/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Titleplaceholder1Inputs */

const he_account_reviews_titleplaceholder1 = /** @type {(inputs: Account_Reviews_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סיכום קצר (אופציונלי)`)
};

const en_account_reviews_titleplaceholder1 = /** @type {(inputs: Account_Reviews_Titleplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief summary (optional)`)
};

/**
* | output |
* | --- |
* | "Brief summary (optional)" |
*
* @param {Account_Reviews_Titleplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const account_reviews_titleplaceholder1 = /** @type {((inputs?: Account_Reviews_Titleplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Titleplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_titleplaceholder1(inputs)
	return en_account_reviews_titleplaceholder1(inputs)
});
export { account_reviews_titleplaceholder1 as "account_reviews_titlePlaceholder" }